import axios from "axios";
const url_api = process.env.REACT_APP_API_URL;
const url_api_descriptionProject=`${url_api}/descriptionproject`
const DescriptionProjectService = {
    getDescriptionProjectByProjectId:async (ProjectId)=>{
        try {
            const response= await axios.get(`${url_api_descriptionProject}/project/${ProjectId}`)
            return response
        } catch (error) {
            return error;
        }
    },

    createDescriptionProject:async (newDocumentProject)=>{
        try {
            const response= await axios.post(url_api_descriptionProject,newDocumentProject)
            return response
        } catch (error) {
            return error;
        }
    },

    updateDescriptionProject:async (ProjectId,newDocumentProject)=>{
        try {
            const response= await axios.put(`${url_api_descriptionProject}/${ProjectId}`,newDocumentProject)
            return response
        } catch (error) {
            return error;
        }
    },
}

export default DescriptionProjectService;